(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2197],{

/***/ 43532:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/404",
      function () {
        return __webpack_require__(37951);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 85666:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "T": function() { return /* reexport */ NotFound; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-intl/lib/src/components/useIntl.js
var useIntl = __webpack_require__(86896);
// EXTERNAL MODULE: ./node_modules/next-translate-routes/link.js
var next_translate_routes_link = __webpack_require__(73966);
var link_default = /*#__PURE__*/__webpack_require__.n(next_translate_routes_link);
// EXTERNAL MODULE: ./src/paths.ts
var paths = __webpack_require__(4032);
// EXTERNAL MODULE: ./src/@next/components/atoms/Button/index.ts + 2 modules
var Button = __webpack_require__(45506);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./src/@next/globalStyles/index.ts + 3 modules
var globalStyles = __webpack_require__(23042);
// EXTERNAL MODULE: ./src/@next/globalStyles/constants.ts
var constants = __webpack_require__(38408);
;// CONCATENATED MODULE: ./src/@next/pages/NotFound/styles.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  text-align: center;\n  padding: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: ",
        ";\n  font-weight: 900;\n  line-height: 100%;\n  color: ",
        ";\n  padding-bottom: 20px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: ",
        ";\n  min-width: ",
        ";\n  height: 2px;\n  margin-top: ",
        ";\n  margin-bottom: ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    p {\n      display: inline;\n    }\n  "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: ",
        ";\n  min-width: 88%;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}


var Page = globalStyles/* styled.div */.zo.div(_templateObject(), "".concat(2 * constants/* spacer */.OF, "rem ").concat(constants/* spacer */.OF, "rem"));
var Header = globalStyles/* styled.h2 */.zo.h2(_templateObject1(), function(param) {
    var typography = param.theme.typography;
    return typography.ultraBigFont;
}, function(props) {
    return props.theme.colors.primary;
});
var Ruler = globalStyles/* styled.div */.zo.div(_templateObject2(), function(props) {
    return props.theme.colors.primary;
}, "".concat(10 * constants/* spacer */.OF, "rem"), "".concat(constants/* spacer */.OF, "rem"), "".concat(3 * constants/* spacer */.OF, "rem"));
var Message = globalStyles/* styled.div */.zo.div(_templateObject4(), globalStyles/* media.smallScreen */.BC.smallScreen(_templateObject3()));
var Action = globalStyles/* styled.div */.zo.div(_templateObject5(), "".concat(2 * constants/* spacer */.OF, "rem 0"));

;// CONCATENATED MODULE: ./src/@next/pages/NotFound/NotFound.tsx







var NotFound = function() {
    var intl = (0,useIntl/* default */.Z)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Page, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Header, {
                children: "404"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Ruler, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Message, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: intl.formatMessage({
                            defaultMessage: "We can’t seem to find a page you are looking for!",
                            id: "A8OWpi"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: intl.formatMessage({
                            defaultMessage: "You may have mistyped the address or the page may have moved.",
                            id: "+qoOl7"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: intl.formatMessage({
                            defaultMessage: "We’re sorry for the error and hope you’ll have a good day.",
                            id: "5wk80E"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Action, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    href: paths/* paths.home */.H.home,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                            color: "secondary",
                            size: "lg",
                            children: intl.formatMessage({
                                defaultMessage: "Back to home",
                                id: "aIRWQB"
                            })
                        })
                    })
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/@next/pages/NotFound/index.tsx



/***/ }),

/***/ 37951:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _pages_NotFound__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85666);

/* harmony default export */ __webpack_exports__["default"] = (_pages_NotFound__WEBPACK_IMPORTED_MODULE_0__/* .NotFound */ .T);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(43532); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);